import { Column, ColumnStore } from '@bryntum/grid';
import {$t} from "../../i18Instance";

export class RmsObjectsGridColumnCurrentOrders extends Column {
    // Define the type for this column, used in your columns config to add this column
    static get type() {
        return 'currentOrdersColumn';
    }

    // Override default values
    static get defaults() {
        return {
            field: 'hasRentsOrRequestsInDate',
            align: 'left',
            cellCls: 'custom-cell-image',
            editor: false,
            htmlEncode: false,

        };
    }

    renderer({ record, value, cellElement, row, size }) {
        if(value === true){
            //let retValue = "Dies ist<br>ein Mehrzeiliger\r\nEintrag\r\n" + value;
            //console.log("rentsinDateList", record.rentsInDate);
            let retValue = '<div>';

            // Hat Anträge im Zeitraum
            for (const rentInDate of record.requestsInDate) {
                row.addCls('row-restricted-availability');
                row.removeCls('row-not-available');
                retValue+= "<div style=\"margin-bottom:8px;\">";
                retValue+= "<a target='_blank' href='"+APP_URL+"/#/request-approve/"+rentInDate.id+"'>" + rentInDate.request_number + "</a> - " + rentInDate.desc + "</br>";
                retValue+= $t('requests.grid.timeframe') + ": " + moment(rentInDate.from).format('DD.MM.YY')+ " - " + moment(rentInDate.until).format('DD.MM.YY') + "</br>";
                retValue+= "</div>";
                // Für jeden Eintrag 25 Pixel in der Höhe dazurechnen
                size.height+=50;
            }

            // Hat Aufträge im Zeitraum
            for (const rentInDate of record.rentsInDate) {
                row.addCls('row-not-available');
                row.removeCls('row-restricted-availability');
                retValue+= "<div style=\"margin-bottom:8px;\">";
                retValue+= "<a target='_blank' href='"+APP_URL+"/orders/"+rentInDate.id+"'>" + rentInDate.number + "</a> - " + rentInDate.desc + "</br>";
                retValue+= $t('requests.grid.timeframe') + ": " + moment(rentInDate.from).format('DD.MM.YY')+ " - " + moment(rentInDate.until).format('DD.MM.YY') + "</br>";
                retValue+= "</div>";
                // Für jeden Eintrag 25 Pixel in der Höhe dazurechnen
                size.height+=50;
            }

            retValue+='</div>';
            return retValue;
            //return record.rentsInDate.length + " vorhanden";
        }else{
            row.removeCls('row-restricted-availability');
            row.removeCls('row-not-available');
            return $t('requests.grid.none-available');
        }

    }
}

ColumnStore.registerColumnType(RmsObjectsGridColumnCurrentOrders);
